import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"
import moment from 'moment'

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import { Grid } from "@material-ui/core";

// Forms

// Assets
import DefaultProfile from "assets/img/default-avatar.png"
import NotificationsChild from "./NotificationsChild";


const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

class Principles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            notifications: [],
        };
    }

    componentDidMount() {

        if (this.props.authUser && !this.state.dataLoaded) {
            this.getNotifications();
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.authUser && !this.state.dataLoaded) {
            this.getNotifications();
        }

    }

    getNotifications = async () => {

        const dispatcherOrdersSnapshot = await db.collection('TEST-orders').where('dispatcherID', '==', this.props.authUser.uid).get();

        const nSnapshots = []
        for (let i = 0; i < dispatcherOrdersSnapshot.docs.length; i++) {
            nSnapshots.push(db.collection('notifications').where('orderID', '==', dispatcherOrdersSnapshot.docs[i].id).get());
        }
        if (!this.props.user.vendorID) return;

        const vendorRef = db.collection('TEST-vendors').doc(this.props.user.vendorID)
        const vendor = await vendorRef.get();
        if (vendor.exists) {
            Promise.all([
                vendorRef.set({ newNotifications: false }, { merge: true }),
                vendorRef.collection('notifications').get()
            ])
                .then(responses => {
                    const [setReturn, vendorNotifications] = responses;

                    const allNotifications = [];
                    for (let i = 0; i < vendorNotifications.docs.length; i++) {
                        const docData = {
                            ...vendorNotifications.docs[i].data(),
                            id: vendorNotifications.docs[i].id
                        }

                        allNotifications.push(docData);
                    }

                    const container = {}
                    allNotifications.filter(item => {
                        console.log(container);
                        if (container[`${item.description} ${String(item.timestamp.toDate())}`]) {
                            return false;
                        } else {
                            container[`${item.description} ${String(item.timestamp.toDate())}`] = true;
                            return true;
                        }
                    })

                    allNotifications.sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1);

                    this.setState({
                        notifications: allNotifications,
                        dataLoaded: true
                    });
                });
        }

    }

    handleClickOpen = (modal) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    render() {
        const { AuthBool, classes, authUser, user } = this.props;

        return this.state.dataLoaded ? (
            <NotificationsChild notifications={this.state.notifications} />
        ) : <p>Loading...</p>;
    }
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
        assessments: state.assessment,
        orders: state.orders.orders
    }
}

const mapDispatchToProps = (dispatch, props) => {
    console.log(props)
    return {
    }
}


// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Principles);


// WEBPACK FOOTER //
// ./src/views/Customer/NotificationsParent.jsx